export function leftPad(d: number, length: number): string {
  let result = d.toString(10)
  while (result.length < length) {
    result = '0' + result
  }
  return result
}
